import React from 'react';

// Types
import { ReviewState } from 'Shared/types/Review.type';

// Helpers
import * as ReviewsHelpers from 'Shared/model_helpers/Reviews.helper';

// Components
import ReviewCard from './ReviewCard';

// Styles
import './ReviewsCardsContainer.scss';

type Props = {
  reviews;
  isPeerReviewForms?: boolean;
};

const ReviewsCardsContainer = ({ reviews, isPeerReviewForms = false }: Props) => {
  if (!reviews) return null;

  const baseClassName = 'ReviewsCardsContainer';
  return (
    <div className={baseClassName}>
      {reviews
        .filter(review => ReviewsHelpers.getState(review) !== ReviewState.CANCELLED)
        .valueSeq()
        .map(review => {
          const slug = ReviewsHelpers.getSlug(review);
          return (
            <ReviewCard
              review={review}
              key={`review-card-${slug}`}
              classname={`${baseClassName}__review`}
              isPeerReviewForm={isPeerReviewForms}
            />
          );
        })}
    </div>
  );
};

export default ReviewsCardsContainer;
